/**
 * This file contains all function to check if the user has the right to do something.
 */

export const hasSaveOptions = (organization) => {
  return organization?.feature_flags?.includes("tags");
};

export const hasRightSetDefaults = (user) => {
  return !!user?.matching_default_providers?.length;
};

export const hasRightLayoutExport = (organization) => {
  return organization?.feature_flags?.includes("layout_export");
};
